export function checkIsValidCPF (cpf) {
  if (!cpf) return false
  cpf = cpf.replace(/[^\d]/g, '') // Remove caracteres não numéricos

  if (cpf.length !== 11 || cpf.match(/(\d)\1{10}/)) {
    return false // CPF deve ter 11 dígitos e não pode ser composto por um único dígito repetido
  }

  let soma = 0
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i)
  }

  let resto = soma % 11
  let digitoVerificador1 = resto < 2 ? 0 : 11 - resto

  if (parseInt(cpf.charAt(9)) !== digitoVerificador1) {
    return false // Primeiro dígito verificador inválido
  }

  soma = 0
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i)
  }

  resto = soma % 11
  let digitoVerificador2 = resto < 2 ? 0 : 11 - resto

  if (parseInt(cpf.charAt(10)) !== digitoVerificador2) {
    return false // Segundo dígito verificador inválido
  }

  return true // CPF válido
}

export function checkIsValidCNPJ (cnpj) {
  if (!cnpj) return false
  cnpj = cnpj.replace(/[^\d]+/g, '')

  if (cnpj.length !== 14) {
    return false
  }

  // Elimina CNPJs inválidos conhecidos
  if (/^(\d)\1{13}$/.test(cnpj)) {
    return false
  }

  // Validação do primeiro dígito verificador
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho)
  let digitos = cnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
  if (resultado !== parseInt(digitos.charAt(0))) {
    return false
  }

  // Validação do segundo dígito verificador
  tamanho = tamanho + 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
  if (resultado !== parseInt(digitos.charAt(1))) {
    return false
  }

  return true
}
